export default "__VITE_ASSET__9f3b623e__"